<template>
	<div style="position: relative;">
		<b-form-input v-model="text" :disabled="disabled" autocomplete="off" v-bind:placeholder="placeHolder" v-bind:state="getValidationState( validationContext )" v-on:input="onChange" v-on:keydown="onNavigate"></b-form-input>
		<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
		<b-list-group v-show="opened" class="fab-list-group">
			<b-list-group-item v-show="loading">Loading...</b-list-group-item>
			<template v-if="labelKey && listItems.length">
				<b-list-group-item v-for="( item, i ) in listItems" v-bind:key="item.id" button v-bind:class="{ 'active': cursor === i }" v-on:click="onSelect( item )" v-html="formatString( item[labelKey] )"></b-list-group-item>
			</template>
			<template v-if="!labelKey && listItems.length">
				<b-list-group-item v-for="( value, i ) in listItems" v-bind:key="i" button v-bind:class="{ 'active': cursor === i }" v-on:click="onSelect( value )" v-html="formatString( value )"></b-list-group-item>
			</template>
		</b-list-group>
	</div>
</template>

<script>
export default {
	name: 'Autocomplete',

	props: {
		value: [String, Object],
		placeHolder: String,
		items: Array,
		endpoint: String,
		delay: {
			type: Number,
			default: 500
		},
		minChars: {
			type: Number,
			default: 3
		},
		labelKey: String,
		validationContext: Object,
		disabled: String
	},

	data () {
		return {
			selected: this.value,
			opened: false,
			loading: false,
			listItems: this.items || [],
			cursor: -1,
			search: ''
		}
	},

	computed: {
		text: {
			get () {
				return this.selected ? typeof this.selected === 'object' ? this.selected[this.labelKey] : this.selected : this.search
			},
			set (value) {
				this.search = value
			}
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null
		},

		async fetchListItems () {
			let response = await this.$axios.get(this.endpoint.replace('{token}', encodeURI(this.search)))
			this.listItems = response.data
			this.loading = false
		},

		onChange () {
			if (timeout) clearTimeout(timeout)
			let previous = this.search
			let timeout = setTimeout(() => {
				if (this.search.length >= this.minChars && previous.length === this.search.length) {
					this.loading = true
					this.opened = true
					this.fetchListItems()
				} else if (this.search.length < this.minChars) {
					this.opened = false
					this.listItems = []
					this.loading = false
				}
			}, this.delay)
		},

		onSelect (value) {
			if (!value) return

			if (this.labelKey && typeof value !== 'object') {
				this.selected = {}
				this.selected[this.labelKey] = value
			} else {
				this.selected = value
			}
			this.opened = false
			this.loading = false
			this.cursor = -1
			this.$emit('input', this.selected)
		},

		onNavigate (event) {
			switch (event.which) {
				case 38: // up arrow
					if (this.cursor > -1) {
						this.cursor--
					}
					break
				case 40: // down arrow
					if (this.cursor < this.listItems.length) {
						this.cursor++
					}
					break
				case 9: // tab
					this.onSelect(this.getListItem())
					break
				case 13: // enter
					event.preventDefault()
					this.onSelect(this.getListItem())
					break
			}
		},

		getListItem () {
			if (!Array.isArray(this.listItems) || this.listItems.length === 0 || this.cursor == -1) {
				return this.search
			} else if (Array.isArray(this.listItems) && this.listItems.length === 1 && ( this.labelKey ? this.listItems[0][this.labelKey] : this.listItems[0] ).toLowerCase() === this.search.toLowerCase()) {
				return this.listItems[0]
			} else {
				return this.listItems[this.cursor]
			}
		},

		formatString (value) {
			if (!value || !value.length) return ''
			return value.replace(new RegExp(this.text, 'gi'), '<strong>$&</strong>')
		}
	},

	watch: {
		value (newValue) {
			if (!newValue) {
				this.search = ''
				this.selected = null
				this.listItems = this.items || []
				this.cursor = -1
				this.loading = false
				this.opened = false
			} else {
				this.onSelect(newValue)
			}
		}
	}
}
</script>

<style lang="scss">
@import "src/assets/variables";

.fab-list-group {
	position: absolute;
	top: 2.5rem;
	left: 0;
	z-index: 100;
	width: 100%;
	background-color: $secondary;

	strong {
		color: $info;
	}
}
</style>
